import {getAbsoluteUrl} from "../../utils/urlUtill";
import {IHttpService} from "angular";

interface Parameter {

}

export class ConditionParameterService {
    private $http: IHttpService;

    static instance = ['$http', ConditionParameterService];

    constructor($http: IHttpService) {
        this.$http = $http;
    }

    updateParameter = parameter => {
        let conditionParameterUrl = 'api/calculators/conditions/parameter';
        return this.$http({
            method: 'PUT',
            url: getAbsoluteUrl(conditionParameterUrl)
        })
    };

}